import React from "react";
import ReactLoading from "react-loading";
import "./SpinLoading.css";
const SpinLoading = (props) => {
  const { width, height, color, delay, type } = props;
  return (
    <>
      <div className="SpinLoading">
        <ReactLoading
          className="SpinLoading_Loader"
          delay={delay} // delay befor appear // number
          type={type ? type : "spin"}
          color={color ? color : "#ffc107"}
          height={height ? height : "10%"}
          width={width ? width : "10%"}
        />
      </div>
    </>
  );
};

export default SpinLoading;
